import React, { FC } from "react";
import { List, ListItem } from "react-toolbox/lib/list";

export interface AdminMenuProps {
    onNavClick(path: string): void;
}

const AdminMenu: FC<AdminMenuProps> = (props: AdminMenuProps) => {
    return (
        <List>
            <ListItem
                leftIcon="home"
                caption="Admin Home"
                onClick={props.onNavClick.bind(undefined, "/admin")}
                selectable
            />
            <ListItem
                leftIcon="business"
                caption="Organizations"
                onClick={props.onNavClick.bind(undefined, "/list")}
                selectable
            />
            <ListItem
                leftIcon="view_list"
                caption="Apps"
                onClick={props.onNavClick.bind(undefined, "/admin/apps")}
                selectable
            />
        </List>
    );
};

export { AdminMenu };
